import { MyIcon, toLocalDate } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PendingIcon from '../icons/PendingIcon';
import { COMMENT_HISTORY_MODAL, STATUS_TYPES } from '../../constants';
import { IServiceStatusHistoryModel } from '../../models/services/IServiceResponseModel';
import classes from './CommentHistoryModal.module.scss';

interface ICommentHistory {
  eventDetailsForHistory?: IServiceStatusHistoryModel[],
}
const CommentHistoryModal = ({ eventDetailsForHistory = undefined }: ICommentHistory) => {
  const { t: translate } = useTranslation();

  const [accData, setAccData] = useState<IServiceStatusHistoryModel[] | undefined>([]);
  const [accShow, setAccShow] = useState(false);

  /**
   * @method generateInitials
   * @description Generates initials from a given name.
   * @param name - The name to generate initials from.
   * @returns The generated initials.
   */
  const generateInitials = (name: string | undefined) => {
    if (name) {
      if (name.split(' ').length > 1) {
        return name
          .split(' ')[0][0]
          .toUpperCase()
          .concat(name.length > 1 ? name.split(' ')[1][0].toUpperCase() : '');
      }
      if (name.split(' ').length === 1) {
        return name[0].toUpperCase();
      }
    }
    return COMMENT_HISTORY_MODAL.GENERATE_INITIALS;
  };

  /**
   * @method handleDateType
   * @description Converts the given date string to a formatted local date string.
   * @param date - The date string to be converted.
   * @returns The formatted local date string.
   */
  const handleDateType = (date?: string) => {
    const dateFormat = COMMENT_HISTORY_MODAL.DATE_FORMAT;
    return toLocalDate({ date: String(date), targetDateFormat: dateFormat });
  };

  useEffect(() => {
    const eventMap = eventDetailsForHistory?.filter((ele: IServiceStatusHistoryModel, index: number) => {
       
      if (index !== eventDetailsForHistory?.length - 1 && ele.status.toUpperCase() === STATUS_TYPES.RETURNED) { return ele; }
      return '';
    });
    setAccData(eventMap);
  }, [eventDetailsForHistory]);

  return (
     
    <span className={accShow ? classes['accord-parent-show-hide-text'] : ''} data-testid="comment-history-container">
      {accShow ? (
        <div className={classes['accord-parent']}>
          <div className={classes['accord-holder']} onClick={() => setAccShow(!accShow)} role="button" tabIndex={0} onKeyDown={() => setAccShow(!accShow)}>
            <span className={classes['accord-holder-heading']}>{translate('comment_history_modal.lbl_hide_past_comments')}</span>
            <MyIcon name="upArrowIcon" />
          </div>
          {accData?.slice(1)?.map((data: IServiceStatusHistoryModel) => (
            <>
              <div className={classes['user-details']}>
                <div className={classes['user-avatar']}>
                  {generateInitials(data.createdBy)}
                </div>
                <div className={classes['user-bio']}>
                  <div className={classes['user-name']} title={data.createdBy}>
                    {data.createdBy}
                  </div>
                  <div className={classes['user-duration']} title={handleDateType(data.createdTimestamp)}>
                    {handleDateType(data.createdTimestamp)}
                  </div>
                </div>
              </div>
              <div className={classes['user-content']}>
                {data.comment}
              </div>
              <div className={classes['user-status']}>
                <span className={classes['chm-align']}>
                  <MyIcon name="checkCircleFillIcon" className={classes['chm-completed']} />
                  {translate('comment_history_modal.lbl_completed')}
                </span>
              </div>
            </>))}
        </div>
      )
        : (
          <div className={classes['return-dialog']}>
            <div className={classes['user-details']}>
              <div className={classes['user-avatar']}>
                {generateInitials(accData && accData[0]?.createdBy)}
              </div>
              <div className={classes['user-bio']}>
                <div className={classes['user-name']} title={accData && accData[0]?.createdBy}>
                  {accData && accData[0]?.createdBy}
                </div>
                <div className={classes['user-duration']} title={handleDateType(accData && accData[0]?.createdTimestamp)}>
                  {handleDateType(accData && accData[0]?.createdTimestamp)}
                </div>
              </div>
            </div>
            <div className={classes['user-content']}>
              {accData && accData[0]?.comment}
            </div>
            <div className={classes['user-status']}>
              <PendingIcon /> {translate('comment_history_modal.lbl_pending')}
            </div>
            {accData && accData?.length >= 2
              && (
                <div className={classes['accord-holder-show-comments']} onClick={() => setAccShow(true)} role="button" tabIndex={0} onKeyDown={() => setAccShow(true)} data-testid="toggle-show-hide">
                  <span className={classes['accord-holder-heading']}>{translate('comment_history_modal.lbl_show_comments')}</span>
                  <MyIcon name="bottonArrowIcon" />
                </div>
              )}
          </div>
        )}
    </span>
  );
};

export default CommentHistoryModal;
